import { LANGUAGE_TEXTS } from 'constants/App';

const reducer = (state = LANGUAGE_TEXTS, action) => {
  return state;
};

export default reducer;
